import React from 'react';
import ProjecaoMensalFlexService from '../../../../lib/api/projecaoMensalFlex/projecaoMensalFlex';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class ProjecaoMensalFlex extends React.Component<{}, {}> {
	constructor(props: any) {
		super(props);
		this.state = {};
	}

	baixarExcelParametrosProjecaoMensalFlex() {
		return ProjecaoMensalFlexService.obterExcel();
	}

	enviarParametrosEventGrid() {
		return ProjecaoMensalFlexService.enviarParametrosAoEventGrid();
	}

	render() {
		return (
			<TemplateParametro
				enviarParametrosEventGrid={this.enviarParametrosEventGrid}
				baixarExcelParametros={this.baixarExcelParametrosProjecaoMensalFlex}
				enviarExcelParametros={ProjecaoMensalFlexService.projecaoMensalFlexExcelPost}
				deletarExcelParametros={ProjecaoMensalFlexService.deletarExcelParametros}
				nomeDoArquivo='Projecao Mensal Flex'
			/>
		);
	}
}

export default ProjecaoMensalFlex;
